export default function NewDocUsers(){
  return(
    <div>
      New Document Users coming soon!
    </div>
  );
}